import React, {Component} from 'react';

import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';

import {no, nn, se, de, de_child, de_adult} from './assets';

import strings from '../../strings';
import {getTestLanguage} from '../../constants/tests';

const ranIntroItemImages = getTestLanguage().ranIntroItemImages;
const ranIntroImages = getTestLanguage().ranIntroImages;
const colors = getTestLanguage().rnColors;

class Intro extends Component {
	constructor(props) {
		super(props);

		switch (strings.getLanguage()) {
			case 'nn':
				this.assets = nn;
				break;
			case 'se':
				this.assets = se;
				break;
			case 'de':
				switch (this.props.testKeyType) {
					case 'child-followup':
						this.assets = de_child;
						this.introtext1 = strings.rn_intro1_child;
						this.introtext2 = ``;
						this.introtext3 = '';
						this.introtext5 = strings.rn_intro5_child;
						this.introtext6 = strings.rn_intro6_child;
						break;
					case 'adult-followup':
						this.assets = de_adult;
						this.introtext1 = strings.rn_intro1_adult;
						this.introtext2 = strings.rn_intro2_adult;
						this.introtext3 = '';
						this.introtext5 = strings.rn_intro9_adult;
						this.introtext6 =  strings.om_intro_adult3;
						break;
					default:
						this.assets = de;
						this.introtext1 = strings.rn_intro1;
						this.introtext2 = '';
						this.introtext3 = '';
						this.introtext5 = strings.rn_intro5;
						this.introtext6 = '';
						break;
				}
				break;
			case 'no':
			default:
				this.assets = no;
				break;
		}

		this.state = {
			stepData: {},
			hasCorrectWordsGiven: false,
			step: 0,
			showFakeBtn: true,
		};
	}

	componentWillReceiveProps(newProps) {
		if (this.props.currentStep !== newProps.currentStep) {
			this.setState({step: newProps.currentStep});
		}
		if (this.props.stepData !== newProps.stepData) {
			const hasCorrectWordsGiven =
				newProps.stepData.hasOwnProperty('correctWordsGiven') &&
				newProps.stepData.correctWordsGiven;

			if (!this.state.hasCorrectWordsGiven && hasCorrectWordsGiven) {
				this.setState({
					hasCorrectWordsGiven,
				});
				this.playSecondClip();
			}
		}
	}

	playSecondClip = () => {
		if (this.audio2) this.audio2.handleStartPlayer();
	};

	render() {
		const step = this.state.step;
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';
		return (
			<div className="RapidNamingIntro">
				{step === 0 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro1}
							/>
							{this.introtext1}
						</p>
						<p>{this.introtext2}</p>

						{this.state.showFakeBtn && (
							<button
								className="lit-btn lit bg-primary"
								onClick={() => {
									this.setState({
										showFakeBtn: false,
									});
								}}
							>
								{'Start'}
							</button>
						)}
					</>
				)}
				{step === 1 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro2}
							/>
							{isAdultFollowup
								? strings.rn_intro3_adult
								: strings.rn_intro2}
						</p>
						<div className="items">
							{colors.map((color) => (
								<div className={`circle ${color}`} />
							))}
						</div>
						<p>{isAdultFollowup && strings.rn_intro4_adult}</p>
					</>
				)}
				{step === 2 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro3}
							/>
							{isAdultFollowup
								? strings.rn_intro5_adult
								: strings.intro3}
						</p>
						<div className="items">
							{ranIntroItemImages.map((item) => (
								<img className="image" src={item} alt="" />
							))}
						</div>
						<p>{isAdultFollowup && strings.rn_intro6_adult}</p>
					</>
				)}
				{step === 3 && (
					<>
						<p>
							<AudioPlayer
								autoplay
								inline
								src={this.assets.intro4}
							/>
							{isAdultFollowup
								? strings.rn_intro7_adult
								: strings.intro4}
						</p>
						<div className="items">
							{ranIntroImages.map((item) => (
								<img className="image" src={item} alt="" />
							))}
						</div>
						<p>{isAdultFollowup && strings.rn_intro8_adult}</p>
					</>
				)}
				{step === 4 && (
					<>
						<p>
							<AudioPlayer
								ref={(node) => (this.audio2 = node)}
								inline
								autoplay
								src={this.assets.intro5}
							/>
							{this.introtext5}
						</p>
						<p>{this.introtext6}</p>
						<ReadyButton
							onReadyChange={this.props.setReady}
							isSpoonerism={false}
							isAdultTest={isAdultFollowup}
						/>
					</>
				)}
			</div>
		);
	}
}

export default Intro;
